<h3 class="heading">Mobie2CAD App <div class="appversion">V.1.1.0</div> </h3>
<div id="container"></div>

<div style="top: 88%;width: 35px;height: 18px;" class="btn_icon" id="btn_m2ccontrol" (click)="openM2CDialog()">
  <i title="M2C Control" class='bx bx-image-add nav_icon'></i>
  <span class="nav_name">M2C</span>
</div>
<div id='m2c_dialog'>
  <div style="display: inline;">
    <label for="textbox">Incident ID:</label>
    <input [disabled]="incidentStarted" style="margin-left: 5px;" [(ngModel)]="incidentId" type="text" size="12"
      id="txt_id_addr" placeholder="Enter Incident ID" />
    </div>
    <div style="padding-top: 10px;">
      <input [disabled]="incidentStarted" type="button" value="Start" id="btn_start" (click)="btn_start_click()" />
      <input type="button" value="Stop" id="btn_stop" (click)="btn_stop_click()" style="margin-left: 5px ;" />
    </div>
    @if (incidentStarted) {
      <pre> Listening to {{ incidentId }} channel</pre>
    }
  </div>
